import createReactContext from '@ant-design/create-react-context';
var FormContext = createReactContext({
  labelAlign: 'right',
  vertical: false
});
export default FormContext;


//////////////////
// WEBPACK FOOTER
// ../~/antd/es/form/context.js
// module id = 317
// module chunks = 0